import {
  Box,
  CircularProgress,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
} from '@material-ui/core';
import { Check, Error } from '@material-ui/icons';
import React from 'react';

export interface ContentProcessingItemProps {
  title: string;
  failedMessage?: string;
  started: boolean;
  complete: boolean;
  failed?: boolean;
  divider?: boolean;
}

const useClasses = makeStyles({
  hidden: { opacity: 0 },
  itemPadding: {
    fontSize: '14px',
    padding: '8px 0',
  },
});

export const ContentProcessingItem: React.FC<ContentProcessingItemProps> = ({
  title,
  started,
  complete,
  failed,
  failedMessage,
  divider,
}) => {
  const classes = useClasses();
  return (
    <ListItem divider={divider}>
      <ListItemIcon>
        {!failed && !started && !complete && <Check className={classes.hidden} />}
        {!failed && started && !complete && <CircularProgress size={24} />}
        {!failed && complete && <Check color="primary" />}
        {failed && <Error color="error" />}
      </ListItemIcon>
      <ListItemText disableTypography classes={{ root: classes.itemPadding }}>
        {title}
        {failed && ' failed,'}
        {failed && failedMessage && ' ' + failedMessage}
      </ListItemText>
    </ListItem>
  );
};

export default ContentProcessingItem;
